import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { SpinWheelMilestoneViewModel } from "@playcharge/common/models/backend/spin-wheel/spin-wheel-milestone-view-model";
import { SpinWheelEditModel } from "@playcharge/common/models/backend/spin-wheel/backoffice/spin-wheel-edit-model";
import { Observable } from "rxjs";
import { ApiUtils } from "../utils/api-utils";
import { ApiRoutes } from "../models/constants/api-routes";

@Injectable({
    providedIn: "root",
})
export class ApiSpinWheelService {
    private _httpClient = inject(HttpClient);

    public getAll(): Observable<SpinWheelMilestoneViewModel[]> {
        return this._httpClient.get<SpinWheelMilestoneViewModel[]>(
            ApiUtils.buildUrl(ApiRoutes.spinWheel.root),
        );
    }

    public updateMilestones(model: SpinWheelEditModel): Observable<SpinWheelMilestoneViewModel[]> {
        return this._httpClient.post<SpinWheelMilestoneViewModel[]>(
            ApiUtils.buildUrl(ApiRoutes.spinWheel.root),
            model,
        );
    }
}
